import React from "react";
import "./statisticBox.scss";

import { Stack } from "react-bootstrap";

const StatisticBox = ({ number, icon, firstWord, text }) => {
  return (
    <div className="statistic-box">
      <Stack gap={1} className="d-flex justify-content-center">
        <div className="icon-statistic">{icon}</div>
        <div className="number-statistic">{number}</div>
        <div>
          <span className="title-statistics">{firstWord}</span> {text}
        </div>
      </Stack>
    </div>
  );
};

export default StatisticBox;
